import isObject from 'lodash/isObject'
import isArray from 'lodash/isArray'
import { getAppData, storage } from '@/utils'
import router from '@/router'

export default {
	fetchTemplateData ({ dispatch, commit, rootGetters, rootState }) {
		commit('loading', 'templates', { root: true })

		const { apiKey } = rootState
		const cacheKey = 'omTemplates' + (apiKey ? 'Auth' : '')
		const setData = ({
			templates,
			userTypes,
			userRecent,
			popular,
			filters,
			features,
		}) => {
			const hasTemplates = templates && isArray(templates)
			const hasFilters   = filters && isArray(filters)
			const hasFeatures  = features && isArray(features)

			if (hasTemplates) {
				commit('templates', templates)
			}

			if (userTypes && isArray(userTypes)) {
				commit('permittedTypes', userTypes)
			}

			if (userRecent) {
				commit('recentTemplates', userRecent)
			}

			if (popular) {
				commit('popular', popular)
			}

			if (hasFilters) {
				commit('filterOptions', filters)
			}

			return hasTemplates && hasFilters && (hasFeatures || !apiKey)
		}

		let toCache = {}
		const cache = val => {
			storage.session.setItem(cacheKey, val)
		}
		const setDataAndCache = (data, set = false) => {
			setData(data)
			toCache = { ...toCache, ...data }
			if (set) {
				cache(toCache)
			}
		}

		if (!apiKey) {
			// Remove cached authenticated results, since we are no longer logged in.
			storage.session.removeItem('omTemplatesAuth')
		}

		return new Promise((resolve, reject) => {
			const finalize = () => {
				commit('doneLoading', 'templates', { root: true })
				resolve()
			}

			const data = storage.session.getItem(cacheKey)
			if (data && setData(data)) {
				return finalize()
			}

			const withError = err => {
				err.explanation = 'Something went wrong while fetching template data.'
				commit('setError', err)
				commit('doneLoading', 'templates', { root: true })
				console.error({ err })
				reject(err)
			}

			const storeFilters = ({ body }) => {
				if (body && isArray(body)) {
					setDataAndCache({ filters: body }, !apiKey)
				}

				// If we don't have a user, we need to find some features.
				if (!rootGetters.userId) {
					// If features exist in the app data, we can depend on those.
					let features = getAppData('features')

					if ((!features || !isArray(features)) && apiKey) {
						// Otherwise, we'll need to fetch the user data.
						return dispatch('fetchMe', {}, { root: true }).then(finalize)
					}
				}

				return finalize()
			}

			const storeTemplates = ({ body }) => {
				if (isObject(body)) {
					setDataAndCache(body, true)
				}

				this._vm.$api.get('templates/filters').then(storeFilters)
			}

			this._vm.$api.get('user-templates')
				.then(storeTemplates)
				.catch(withError)
		})
	},
	goToFilteredView ({ commit }, { type, push = true }) {
		commit('setActiveType', type)

		router[push ? 'push' : 'replace']({ name: 'template-type', params: { type } })
	},
}
